/*
 * CarJourneyReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import ActionTypes from "./constants";
import { AppActions, InitialStateType } from "./types.d";

const initialState: InitialStateType = {
  vehicles: [],
  popularVehicles: [],
  isFetching: null,
  isSuccess: null,
  isFailure: null
};

function mmvReducer(state = initialState, action: AppActions) {
  switch (action.type) {
    case ActionTypes.GET_MMV_DATA_REQUEST:
      return { ...state, isFetching: true, isSuccess: null, isFailure: null };
    case ActionTypes.GET_MMV_DATA_SUCCESS:
      return {
        ...state,
        vehicles: [...action.payload.vehicles,...action.payload.popularVehicles],
        popularVehicles: action.payload.popularVehicles,
        isFetching: false,
        isSuccess: true,
        isFailure: false
      };
    case ActionTypes.GET_MMV_DATA_FAILURE:
      return {
        ...state,
        vehicles: [],
        popularVehicles: [],
        isFetching: false,
        isSuccess: false,
        isFailure: true
      };
    default:
      return state;
  }
}

export default mmvReducer;
